import { useMemo } from 'react'
import { skipToken } from '@reduxjs/toolkit/query'

import { sameResourceId } from '@krp/client-runtime'
import { platformMyResources, type PlatformMyResourcesArgs } from '@krp/platform-ui'

import { useAppSelector } from '../../app/hooks'

/**
 * Ревизия настроек ресурса из Platform (`me/resources`, AU1b) для первой
 * команды native-окна: окно пишет сразу, не дожидаясь своего чтения. Список
 * «моих ресурсов» с правом окна — тот, что разрешает сервер, а реестрового
 * права (`platform:registry:read`) у человека может и не быть. Нет ресурса в
 * списке или ответа — `null`: окно ждёт ревизию из ответа службы, как раньше.
 */
export function useResourceRevision(resourceId: string, kind: string, capability: string): string | null {
  const args = useMemo<PlatformMyResourcesArgs>(() => ({ kind, capability }), [capability, kind])
  platformMyResources.useQuerySubscription(resourceId === '' ? skipToken : args, { refetchOnMountOrArgChange: true })
  const select = useMemo(() => platformMyResources.select(args), [args])
  const query = useAppSelector(select)
  if (query.isError || query.data === undefined) return null
  return query.data.find((resource) => sameResourceId(resource.id, resourceId))?.configurationVersion ?? null
}
